import React, { Component } from "react";
import { connect } from 'react-redux';
import { sideNavMenuActions } from '../../../store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import { circuitUsageActions } from '../../../store/external/circuit-usage-reducer/circuit-usage.reducer';
import SubscriptionHeader from "../dashboard/subscription-header/header-subscription.component"
import DeviceInventory from "./device-inventory/device-inventory.component";
import { NoSubscription } from "./no-subscription/no-subscription.component";
import Translation from "../../common/translation/translation.component";
import { DASHBOARD_MENU, DASHBOARD_TAB } from '../../../utils/constant.utils';
import { validateAccessModule } from '../../../utils/helpers.utils';
import { MATRIX_INDICATOR, ACCESS_MODULE } from '../../../utils/rbac-constants.utils';

class DashboardPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeMenu: DASHBOARD_MENU.Personal,
            isLoadingSubscriptions: false,
            mobileSearchString: '',
            homeSearchString: '',
            verticaltabItem: [],
            allSubscribers: [],
            subscriptionHeader: {
                graphHeader: "Statistics",
                firstLineColor: "#008eff",
                secondLineColor: "#be82ff",
                thirdLineColor: "#f580c0",
                forthLineColor: "#f49342"
            },
            planInfo: null,
            equipmentModel: null,
            isLoadingSubscriber: true,
        };
        this.onChangeMenu = this.onChangeMenu.bind(this);
        this.getCurrentSelectedUser = this.getCurrentSelectedUser.bind(this);
        this.fetchAllSubscribers = this.fetchAllSubscribers.bind(this);
    }

    async componentDidMount() {
        const { setIsPersonal, fetchActiveSubscribers } = this.props;
        var employeId = sessionStorage.EmployeeID;

        var disableMenu = this.props.activeMenu == DASHBOARD_MENU.Personal ?
            validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])
            : validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyDirectReportsDashboardR, ACCESS_MODULE.MyDirectReportsDashboardRE, ACCESS_MODULE.MyDirectReportsDashboardRW]);

        this.fetchAllSubscribers();
        await this.props.fetchAllSubscribersViewMore();

        var IsEnabledWirelineTab = JSON.parse(sessionStorage.getItem('IsEnabledWirelineTab'));

        const verticaltabItem = [
            {
                listTitle: <Translation translationKey="mobile_cellular" />,
                disable: disableMenu,
            },
        ];

        if (IsEnabledWirelineTab) {
            verticaltabItem.push({
                listTitle: <Translation translationKey="home_landline" />,
                disable: disableMenu,
            });
        }

        this.setState({ verticaltabItem });

        if (this.state.activeMenu === DASHBOARD_MENU.Personal) {
            setIsPersonal(true);
        } else {
            setIsPersonal(false);
        }
        this.clearSearch(true);
        this.clearSearch(false);
        fetchActiveSubscribers(employeId);
        this.selectedTab(DASHBOARD_TAB.MobileWireless);
    }

    componentDidUpdate(prevProps) {
        const {
            activeMenu,
            setActiveCircuit,
            activeCircuit,
            triggerIsPrimaryIndicator,
            mobileItems,
            homeItems,
            setActiveItemPrimary,
            selectedUser,
            clearSubscriptionItems,
            fetchSubscriptionItems,
            mobileSearchValue,
            homeSearchValue,
            clearCircuitData,
            clearActiveCircuit,
            activeTabKey,
            setActiveTabKey,
            fetchCircuitData,
            fetchUsageSpendDetails,
            fetchActiveSubscribers
        } = this.props;

        const subscriptionList = [...mobileItems.Data, ...homeItems.Data];
        if ( activeMenu !== prevProps.activeMenu) {
            this.setState({                
                isLoadingSubscriptions: false,
                mobileSearchString: '',
                homeSearchString: '',
            });
            this.onChangeMenu(activeMenu);
            fetchActiveSubscribers(sessionStorage.EmployeeID);
            this.selectedTab(DASHBOARD_TAB.MobileWireless);
        }

        if (
            (prevProps.mobileItems.isBeforeFetch || prevProps.homeItems.isBeforeFetch) &&
            !mobileItems.isBeforeFetch &&
            !homeItems.isBeforeFetch &&
            subscriptionList.length &&
            (activeCircuit && !activeCircuit.CircuitId)
        ) {
            if (subscriptionList.find((y) => y.IsPrimaryNumber === true)) {
                setActiveCircuit(subscriptionList.find((y) => y.IsPrimaryNumber === true));
            } else {
                setActiveCircuit(subscriptionList[0]);
            }

            if (!mobileItems.Data.length) {
                setActiveTabKey(2);
            }
        }

        if (prevProps.activeTabKey !== activeTabKey) {
            if (activeTabKey === 1 && mobileItems.Data.length) {
                setActiveCircuit(mobileItems.Data[0]);
            } else if (activeTabKey === 2 && homeItems.Data.length) {
                setActiveCircuit(homeItems.Data[0]);
            }
        }

        if (activeCircuit && activeCircuit.CircuitId && triggerIsPrimaryIndicator && !prevProps.triggerIsPrimaryIndicator) {
            const circuit = subscriptionList.find((y) => y.CircuitId === activeCircuit.CircuitId);

            if (circuit) {
                circuit.IsPrimaryNumber = true;
                setActiveCircuit(circuit);
                setActiveItemPrimary(circuit);
            }
        }

        if (selectedUser.EmployeeId && selectedUser.EmployeeId !== prevProps.selectedUser.EmployeeId) {
            this.clearSearch(true);
            this.clearSearch(false);
            clearCircuitData();
            clearActiveCircuit();
            clearSubscriptionItems(true);
            clearSubscriptionItems(false);
        }

        if (!mobileItems.isFetching && prevProps.mobileSearchValue !== mobileSearchValue) {
            clearSubscriptionItems(true);
        }

        if (!homeItems.isFetching && prevProps.homeSearchValue !== homeSearchValue) {
            clearSubscriptionItems(false);
        }

        if (activeCircuit && activeCircuit.CircuitId
            && (!prevProps.activeCircuit || activeCircuit.CircuitId !== prevProps.activeCircuit.CircuitId)) {
            
            this.setState({
                convertCurrency: false,
            });
            clearCircuitData();
            if (activeCircuit && activeCircuit.CircuitId != null) {
                fetchCircuitData(activeCircuit.CircuitId, activeCircuit.FinanceAccountId);
                fetchUsageSpendDetails(activeCircuit.CircuitId);
            }
        }

        if (activeMenu === DASHBOARD_MENU.MyDirectReport && selectedUser.EmployeeId === null) {
            setActiveCircuit(null);
        }
        if (this.props.circuitData
            && this.props.circuitData.subscriptionInfo
            && (!prevProps.circuitData
                || !prevProps.circuitData.subscriptionInfo
                || this.props.circuitData.subscriptionInfo.PlanDetails !== prevProps.circuitData.subscriptionInfo.PlanDetails
                || this.props.circuitData.subscriptionInfo.EquipmentModel !== prevProps.circuitData.subscriptionInfo.EquipmentModel)) {
            this.setState({
                planInfo: this.props?.circuitData?.subscriptionInfo?.PlanDetails?.length,
                equipmentModel: this.props.circuitData.subscriptionInfo.EquipmentModel,
            });
        }
    }

    async fetchAllSubscribers(searchString = '', subscriberListPage) {

        await this.props.fetchAllSubscribers(searchString, subscriberListPage);
        const allSubscribers = this.props.subscribers;
        
         this.setState({ allSubscribers, isLoadingSubscriber: false });
     }

    clearSearch = (isMobile) => {
        var type = isMobile ? 'mobileSearchString' : 'homeSearchString';

        this.setState({
            [type]: '',
        });

        this.props.clearSearchValue(isMobile);
    };

    onChangeMenu = (params) => {
        const { clearSelectedUser
            , clearCircuitData
            , clearActiveCircuit
            , clearSubscriptionItems
            , fetchActiveSubscribers
            , setActiveTabKey
            , setIsPersonal
            , noSubscriptionItems
        } = this.props;

        clearSelectedUser();
        clearCircuitData();
        clearActiveCircuit();
        setActiveTabKey(params ? params : DASHBOARD_MENU.Personal);

        clearSubscriptionItems(true);
        clearSubscriptionItems(false);
        this.clearSearch(true);
        this.clearSearch(false);

        if (params === DASHBOARD_MENU.Personal) {
            setIsPersonal(true);
        } else {
            setIsPersonal(false);
            noSubscriptionItems();
            fetchActiveSubscribers(sessionStorage.EmployeeID);
        };

        this.setState({ activeMenu: params });
    };

    selectedTab = async (clickTab) => {
        const {
            setActiveCircuit
            , clearActiveCircuit
            , clearSubscriptionItems
            , fetchSubscriptionItems
            , clearCircuitData
        } = this.props;
        clearActiveCircuit();
        clearCircuitData();
        clearSubscriptionItems(true);
        clearSubscriptionItems(false);
        this.setState({ tabSelected: clickTab });
        this.getSubscriptionItems(clickTab);
    }

    getSubscriptionItems = async (tabName) => {
        if (this.props.mobileItems.renderLimit == 1 || this.props.homeItems.renderLimit == 1) {
            if (tabName === DASHBOARD_TAB.MobileWireless) {
                await this.props.fetchSubscriptionItems(true, 0);
                const subscriptionList = [...this.props.mobileItems.Data];
                const circuit = subscriptionList[0];
                this.setState({
                    convertCurrency: false,
                });
                this.props.setActiveCircuit(circuit);
            } else if (tabName === DASHBOARD_TAB.FixedLineWireLine) {
                await this.props.fetchSubscriptionItems(false, 0, true);
                const subscriptionList = [...this.props.homeItems.Data];
                const circuit = subscriptionList[0];
                this.setState({
                    convertCurrency: false,
                });
                this.props.setActiveCircuit(circuit);
            }
        }
    }

    selectedActiveCircuit = circuitId => {
        const {
            setActiveCircuit
            , mobileItems
            , homeItems
        } = this.props;
        const subscriptionList = [...mobileItems.Data, ...homeItems.Data];
        const circuit = subscriptionList.find((y) => y.CircuitId === circuitId);
        this.setState({
            convertCurrency: false,
        });
        setActiveCircuit(circuit);
    }

    triggerSearch = (isMobile, SearchString) => {
        var type = isMobile ? 'mobileSearchString' : 'homeSearchString';
        this.setState({
            [type]: SearchString,
        });
        this.props.clearSearchValue(isMobile);
        this.props.setSearchValue(isMobile, SearchString);

        var tabName = isMobile ? DASHBOARD_TAB.MobileWireless : DASHBOARD_TAB.FixedLineWireLine;
        this.getSubscriptionItems(tabName);
    };

    clearSearchField = async (isMobile) => {
        this.props.clearSearchValue(isMobile);
        await this.props.fetchSubscriptionItems(isMobile, 0);
    };

    getCurrentSelectedUser() {
        const { activeMenu, selectedUser, activeCircuit } = this.props;
        var userModel = JSON.parse(sessionStorage.getItem('User')).Employee;
        var userFullName = userModel.LastName + ", " + userModel.FirstName;
        if (activeMenu === DASHBOARD_MENU.MyDirectReport) {
            userFullName = (selectedUser && activeCircuit && activeCircuit.UserId === selectedUser.EmployeeId) ? selectedUser.FullName : userFullName;
        }
        return userFullName;
    }

    render() {
        const { history, activeMenu, mobileItems, homeItems, circuitData, activeCircuit, noExchangeRate, otherSubscribersList,
            setSelectedUser, clearSelectedUser, clearCircuitData, clearActiveCircuit, clearSubscriptionItems, selectedUser, selectedToggleTab,
            onChangeUserSearch, clearSearchValue, fetchCircuitData, circuitDataUsage, selectedUsageMonth, onUsageMonthSelect, setCurrentToggleTab,
            usageMonthOptions, usageSpendLineData, usageSpendBarData, fetchUsageSpendDetails, usageSpendCurrMonthTotal, setAsPrimary } = this.props;
        const { subscriptionHeader, convertCurrency } = this.state;
        let userFullName = this.getCurrentSelectedUser();

        let noAccess = activeMenu == DASHBOARD_MENU.Personal ?
            validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])
            : false;

        
        return (
            <div className="container-mt-7 personal-main-container">
                <DeviceInventory
                    activeMenu={activeMenu}
                    tabItem={mobileItems}
                    verticaltabItem={this.state.verticaltabItem}
                    lineList={homeItems} circuitData={circuitData}
                    ontabSelected={this.selectedTab}
                    onActiveCiruitSelected={this.selectedActiveCircuit}
                    clearSearch={this.clearSearch}
                    triggerSearch={this.triggerSearch}
                    otherSubscribersList={otherSubscribersList}
                    setSelectedUser={setSelectedUser}
                    onChangeUserSearch={onChangeUserSearch}
                    clearSelectedUser={clearSelectedUser}
                    clearCircuitData={clearCircuitData}
                    clearActiveCircuit={clearActiveCircuit}
                    clearSubscriptionItems={clearSubscriptionItems}
                    selectedUser={selectedUser}
                    clearSearchValue={clearSearchValue}
                    fetchCircuitData={fetchCircuitData}
                    fetchUsageSpendDetails={fetchUsageSpendDetails}
                    activeCircuit={activeCircuit}
                    setCurrentToggleTab={setCurrentToggleTab}
                    selectedToggleTab={selectedToggleTab}
                    clearSearchField={this.clearSearchField}
                    planInfo={this.state.planInfo}
                    equipmentModel={this.state.equipmentModel}
                    allSubscribers={this.props.subscribers}
                    isLoadingSubscriber={this.state.isLoadingSubscriber}
                    fetchAllSubscribers={this.fetchAllSubscribers}
                    subscriberDataList={this.props.subscriberDataList}
                    subscriberListPage={this.props.subscriberListPage}
                    fetchAllSubscribersViewMore={this.props.fetchAllSubscribersViewMore}
                    hasMoreSubscriberView={this.props.hasMoreSubscriberView}
                    viewMoreFetching={this.props.viewMoreFetching}
                    hasMoreCircuitView={this.props.hasMoreCircuitView}
                    fetchSubscriptionItems={this.props.fetchSubscriptionItems}
                />
                {(mobileItems.isFetching || homeItems.isFetching ) ?
                    <NoSubscription title={<Translation translationKey="loading" />} />
                    : this.props.activeCircuit && !noAccess ? 
                        circuitData !== null ? 
                            circuitData.subscriptionInfo !== null ? 
                                circuitData.subscriptionInfo.length !== 0 ? 
                                    (circuitDataUsage && circuitDataUsage.usageDetails) ?
                                        <SubscriptionHeader
                                            history={history}
                                            activeMenu={activeMenu}
                                            key={circuitData.subscriptionInfo}
                                            activeCircuit={this.props.activeCircuit}
                                            convertCurrency={convertCurrency}
                                            noExchangeRate={noExchangeRate}
                                            //usageSpendBarData={circuitData.usageSpendData.summaryUsageSpendBreakdown.currentMonthUsageSpend}
                                            //usageSpendLineData={circuitData.usageSpendData.summaryUsageSpendBreakdown.currentMonthBreakdown}
                                            //usageSpendLineDataSix={circuitData.usageSpendData.summaryUsageSpendBreakdown.sixMonthsUsageSpend}
                                            usageChart={circuitDataUsage.usageDetails != null ? circuitDataUsage.usageDetails.Usage : null}
                                            spendChart={circuitDataUsage.usageDetails != null ? circuitDataUsage.usageDetails.Spend : null}
                                            currencySymbol={circuitData.subscriptionInfo.CurrencySymbol}
                                            circuitStatus={circuitData.subscriptionInfo.CircuitStatusId}
                                            simCount={circuitData.subscriptionInfo.SimCount}
                                            simType={circuitData.subscriptionInfo.SimType}
                                            equipmentCount={circuitData.subscriptionInfo.EquipmentCount}
                                            equipmentModel={circuitData.subscriptionInfo.EquipmentModel}
                                            equipmentType={circuitData.subscriptionInfo.EquipmentType}
                                            planName={circuitData.subscriptionInfo.PlanName}
                                            planInfo={circuitData.subscriptionInfo.PlanDetails}
                                            subscriptionType={circuitData.subscriptionInfo.PlanName}
                                            subscriptionIsPrimary={activeCircuit.IsPrimaryNumber}
                                            phoneNumberType={circuitData.subscriptionInfo.CircuitTypeName}
                                            userPhoneNumber={circuitData.subscriptionInfo.SubscriptionNum}
                                            userName={userFullName}
                                            title={<Translation translationKey="subscription_overview" />}
                                            fetchCircuitData={fetchCircuitData}
                                            vendorName={circuitData.subscriptionInfo.VendorName}
                                            firstLineColor={subscriptionHeader.firstLineColor}
                                            secondLineColor={subscriptionHeader.secondLineColor}
                                            thirdLineColor={subscriptionHeader.thirdLineColor}
                                            forthLineColor={subscriptionHeader.forthLineColor}
                                            graphHeader={subscriptionHeader.graphHeader}
                                            setAsPrimary={setAsPrimary}
                                            selectedUsageMonth={selectedUsageMonth}
                                            onUsageMonthSelect={onUsageMonthSelect}
                                            usageMonthOptions={usageMonthOptions}
                                            usageSpendCurrMonthTotal={usageSpendCurrMonthTotal}
                                            noAccess={noAccess}
                                            vendorLogo={circuitData.subscriptionInfo.VendorLogo}
                                            upgradeEligibilityDate={circuitData.subscriptionInfo.UpgradeEligibilityDate}
                                        />
                                        : <NoSubscription title={<Translation translationKey="loading" />} />
                                    : <NoSubscription title={<Translation translationKey="loading" />} />
                                : <NoSubscription title={<Translation translationKey="loading" />} />
                            : <NoSubscription/>
                        : !noAccess ?
                            (selectedUser.EmployeeId == null && activeMenu === DASHBOARD_MENU.MyDirectReport ?
                                  <NoSubscription title={<Translation translationKey="no_user_selected" />} hideIcon={true} />
                                : <NoSubscription title={<Translation translationKey="no_subscriptions_found" />} hideIcon={true} />)
                            : <NoSubscription title={"Forbidden Access"} hideIcon={true} />
                }

                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { sideNavMenu, circuitUsage, translation } = state;
    return {
        triggerIsPrimaryIndicator: circuitUsage.isPrimaryIndicator,
        ...sideNavMenu,
        ...circuitUsage,
        ...translation,
    };
};

const mapDispatchToProps = {
    ...sideNavMenuActions,
    ...circuitUsageActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
